import React from "react";
import ShowAfterDelay from "./ShowAfterDelay";
import { isPresent } from "src/utils/checks";
import ClientOnly from "components/ClientOnly";

const UrgencyBox = React.lazy(() => import("./UrgencyBox"));

type Props = {
  destinationWebCode: string | undefined;
  title: string;
  content: string;
  ctaLabel?: string;
  ctaUrl?: string;
};

const visibleInDestinationWebCodes = [
  "destination-1", // "Mediterranean"
  "destination-10", // "Antarctica"
  //11, // "Arctic \u0026 Greenland"
  // 13, // "Asia"
  "destination-2", // "Northern Europe \u0026 The British Isles "
  //21, // "Russian Far East"
  "destination-23" // "Galápagos Islands"
  // 25, // "Australia \u0026 New Zealand"
  // 26, // "French Polynesia \u0026 Pacific"
  // 28, // "American West Coast "
  // 29, // "Kimberley"
  // 3, // "Africa \u0026 Indian Ocean"
  // 5, // "Canada \u0026 New England"
  // 6, // "Caribbean \u0026 Central America"
  // 7, // "South America"
  // 8, // "Transoceanic"
  // 9 // "Alaska "
];

const MaybeKeepBooking: React.FC<Props> = ({
  destinationWebCode = "destination-0",
  title,
  content,
  ctaLabel,
  ctaUrl
}) => {
  const isActive =
    visibleInDestinationWebCodes.includes(destinationWebCode) &&
    isPresent(ctaUrl);
  if (!isActive) return null;

  return (
    <ClientOnly>
      <ShowAfterDelay enabled>
        <React.Suspense>
          <UrgencyBox
            title={title}
            content={content}
            ctaLabel={ctaLabel}
            ctaUrl={ctaUrl}
          />
        </React.Suspense>
      </ShowAfterDelay>
    </ClientOnly>
  );
};

export default MaybeKeepBooking;
